<div class="page-content">
    <div class="row justify-content-center">
        <div class="col-xxl-6 col-xl-6 col-lg-6 pt-5 pb-5 justify-content-center">
            <div class="login-area bg-light">
                <div *ngIf="message" class="mt-3 text-center"
                    [ngClass]="{'text-success': isSuccess, 'text-danger': !isSuccess}">
                    {{ message }}
                </div>
                <div *ngIf="currentStep === 'request_otp'">
                    <h2 class="text-secondary text-center">Forgot Password</h2>
                    <p class="text-center m-b25">Enter your e-mail address below to reset your password.</p>
                    <form (ngSubmit)="onRequestOtp()">
                        <div class="m-b30">
                            <label class="label-title">Email Address</label>
                            <input name="email" required class="form-control" placeholder="Email Address" type="email"
                                [(ngModel)]="email">
                        </div>
                        <div class="d-flex justify-content-between">
                            <a routerLink="/login" class="btn btn-outline-secondary btnhover text-uppercase">Back to
                                Login</a>
                            <button type="submit" class="btn btn-secondary btnhover text-uppercase submit-btn"
                                [disabled]="isLoading">
                                {{ isLoading ? 'Sending...' : 'Send OTP' }}
                            </button>
                        </div>
                    </form>
                </div>
                <div *ngIf="currentStep === 'reset_password'" class="">
                    <h2 class="text-secondary text-center">Reset Password</h2>
                    <p class="text-center m-b25">Almost done, enter the OTP sent to your email and your new
                        password.</p>
                    <form (ngSubmit)="onResetPassword()">
                        <div class="m-b30">
                            <label class="label-title">OTP</label>
                            <input name="otp" required class="form-control" placeholder="Enter OTP" type="text"
                                [(ngModel)]="otp">
                        </div>
                        <div class="m-b30">
                            <label class="label-title">New Password</label>
                            <div class="secure-input">
                                <input type="password" name="newPassword" class="form-control dz-password"
                                    placeholder="New Password" [(ngModel)]="newPassword">
                                <div class="show-pass">
                                    <i class="eye-open fa-regular fa-eye"></i>
                                </div>
                            </div>
                        </div>
                        <div class="m-b30">
                            <label class="label-title">Confirm Password</label>
                            <div class="secure-input">
                                <input type="password" name="confirmPassword" class="form-control dz-password"
                                    placeholder="Confirm Password" [(ngModel)]="confirmPassword">
                                <div class="show-pass">
                                    <i class="eye-open fa-regular fa-eye"></i>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <button type="button" class="btn btn-outline-secondary btnhover text-uppercase"
                                (click)="backToRequestOtp()">Back</button>
                            <button type="submit" class="btn btn-secondary btnhover text-uppercase sign-btn"
                                [disabled]="isLoading">
                                {{ isLoading ? 'Resetting...' : 'Reset Password' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>